import React from 'react'
import { Box, Center, Text, Group, Grid, Paper } from '@mantine/core'
import { TextHeading } from '@/components'
import { useCountdown } from '@/hooks'
import { AIRDROP_CONFIG } from '@/config'

const target = new Date(AIRDROP_CONFIG.endDate)

const AirdropCountdownTimer = () => {
  const { days, hours, minutes, seconds } = useCountdown({ target })

  return (
    <Group align="top" spacing="xs" noWrap>
      <Grid sx={{ width: '100%' }} gutter="xs">
        <Grid.Col span={4}>
          <Paper withBorder py="xs" px="sm">
            <TextHeading
              sx={(t) => ({
                fontSize: t.other.airdropWalletConnect.durationFontSize,
                fontVariableNumeric: 'tabular-nums'
              })}>
              {days}
            </TextHeading>
            <Text size="xs" transform="uppercase" sx={(t) => ({ color: t.colors.gray[7] })}>
              Days
            </Text>
          </Paper>
        </Grid.Col>

        <Grid.Col span={4}>
          <Paper withBorder py="xs" px="sm">
            <TextHeading
              sx={(t) => ({
                fontSize: t.other.airdropWalletConnect.durationFontSize,
                fontVariableNumeric: 'tabular-nums'
              })}>
              {hours}
            </TextHeading>
            <Text size="xs" transform="uppercase" sx={(t) => ({ color: t.colors.gray[7] })}>
              Hours
            </Text>
          </Paper>
        </Grid.Col>

        <Grid.Col span={4}>
          <Paper withBorder py="xs" px="sm">
            <TextHeading
              sx={(t) => ({
                fontSize: t.other.airdropWalletConnect.durationFontSize,
                fontVariableNumeric: 'tabular-nums'
              })}>
              {minutes}
            </TextHeading>
            <Text size="xs" transform="uppercase" sx={(t) => ({ color: t.colors.gray[7] })}>
              Minutes
            </Text>
          </Paper>
        </Grid.Col>
      </Grid>

      <Box>
        <Paper withBorder py="xs" px="xs" sx={{ width: 40, height: 40 }}>
          <Center sx={{ height: '100%' }}>
            <TextHeading
              sx={(t) => ({
                fontSize: t.other.airdropWalletConnect.secondsFontSize,
                letterSpacing: t.other.airdropWalletConnect.secondsLetterSpacing,
                fontVariableNumeric: 'tabular-nums'
              })}>
              {seconds}
            </TextHeading>
          </Center>
        </Paper>
      </Box>
    </Group>
  )
}

export { AirdropCountdownTimer }
